export default "<div id='loader'>Loading....</div>\n"